import style from "./UserInfoManagementLayout.module.css";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import { useEffect, useRef, useState } from "react";
import { adminFileRequester, adminRequester } from "App";
import TableSearchCard from "routes/table/search/TableSearchCard";
import SingleAdminTable from "../table/SingleAdminTable";
import P from "components/P";
import NiceModal from "@ebay/nice-modal-react";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import TableButton from "../table/TableButton";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import clsx from "clsx";
import { t } from "i18next";
import ToolTip from "components/tooltip/tooltip";
import AdminImage from "components/Image/AdminImage";
import { useHotkeys } from "react-hotkeys-hook";
import InputNumber from "components/inputs/InputNumber";
import AdminCustomButton, {
  style as buttonStyle,
} from "components/buttons/AdminCustomButton";

export const limit = 20;

function UserInfoManagementLayout() {
  const [count, setCount] = useState(0);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [maxPage, setMaxPage] = useState(0);
  const [searchCondition, setSearchCondition] = useState();
  const { keyword } = useParams();
  //   const [outs, setOuts] = useState([]);
  const [buttons, setButtons] = useState([]);
  const [reset, setReset] = useState(false);
  const [research, setResearch] = useState(false);
  const [extraCondition, setExtraCondition] = useState({});
  const [views, setViews] = useState([]);
  const [theader, setTheader] = useState([]);
  const [search, setSearch] = useState(7);
  //   const researchInterval = useRef();
  const navigate = useNavigate();
  const onDownload = (url, name) => {
    // fetch(url, {
    //   method: "GET",
    //   mode: "cors",
    // })
    //   .then((response) => response.blob())
    //   .then((blob) => {
    //     const url = window.URL.createObjectURL(blob);
    //     const element = document.createElement("a");

    //     element.setAttribute("href", url);
    //     const type = url.includes(".") ? url.split("\\.") : ["png"];
    // element.setAttribute("download", `${name}.${type[type.length - 1]}`);

    //     document.body.appendChild(element);

    //     element.click();

    //     element.parentNode.removeChild(element);
    //     window.URL.revokeObjectURL(url);
    //   });
    adminFileRequester.download(url, name);
  };
  const Word = ({ width, text }) => {
    return text && text !== "" ? (
      <ToolTip
        style={{
          zIndex: 1,
          backgroundColor: "white",
          width: "max-content",
          padding: 5,
        }}
        title={<P>{text}</P>}
      >
        <P
          wordBreak="keep-all"
          textOverflow="ellipsis"
          width={width}
          overflow="hidden"
          whiteSpace="nowrap"
        >
          {text}
        </P>
      </ToolTip>
    ) : (
      <P>데이터 없음</P>
    );
  };
  const openDetail = ({ row }) => {
    NiceModal.show("customerStatus", {
      data: row,
      onSuccess: () => setResearch(true),
    });
  };
  const openEdit = ({ row }) => {
    NiceModal.show("customerEdit", {
      data: row,
      onSuccess: () => setResearch(true),
    });
  };
  const theaderList = [
    {
      width: 25,
      text: "No.",
      justifyContent: "flex-start",
      Cell: ({ index }) => index + 1,
      index: "0",
    },
    {
      width: 60,
      text: "이름",
      justifyContent: "flex-start",
      Cell: ({ row }) => (
        <ToolTip
          style={{
            zIndex: 10,
            padding: 3,
            border: "1px solid black",
            backgroundColor: "white",
          }}
          title={
            <P>
              {`${row.first_name ? row.first_name : ""}${
                row.first_name && row.last_name ? " " : ""
              }${row.last_name ? row.last_name : ""}`}
            </P>
          }
        >
          <P width={60} ellipsis>
            {`${row.first_name ? row.first_name : ""}${
              row.first_name && row.last_name ? " " : ""
            }${row.last_name ? row.last_name : ""}`}
          </P>
        </ToolTip>
      ),
      index: "1",
    },
    {
      width: 70,
      text: "이메일",
      justifyContent: "flex-start",
      code: "email",
      Cell: ({ cell }) => <Word text={cell} width={70} />,
      index: "2",
    },
    {
      width: 70,
      text: "상호",
      justifyContent: "flex-start",
      code: "businessMutual",
      Cell: ({ cell }) => <Word text={cell} width={70} />,
      index: "3",
    },
    {
      width: 80,
      text: "사업자번호",
      justifyContent: "flex-start",
      code: "businessNumber",
      Cell: ({ cell }) => <Word text={cell} width={80} />,
      index: "4",
    },
    {
      width: 80,
      text: "대표자 성함",
      justifyContent: "flex-start",
      code: "businessName",
      index: "5",
    },
    {
      width: 100,
      text: "사업자 주소",
      justifyContent: "flex-start",
      code: "businessAddress",
      Cell: ({ cell }) => <Word text={cell} width={100} />,
      index: "6",
    },
    {
      width: 100,
      text: "대표자 전화번호",
      justifyContent: "flex-start",
      code: "businessPhone",
      index: "7",
    },
    {
      width: 100,
      text: "대표자 이메일",
      justifyContent: "flex-start",
      code: "businessEmail",
      Cell: ({ cell }) => <Word text={cell} width={100} />,
      index: "8",
    },
    {
      width: 80,
      text: "업태",
      justifyContent: "flex-start",
      code: "businessType",
      index: "9",
    },
    {
      width: 80,
      text: "업종",
      justifyContent: "flex-start",
      code: "businessDetail",
      index: "10",
    },
    {
      width: 50,
      text: "사업자 등록증",
      justifyContent: "flex-start",
      code: "businessCertificate",
      Cell: ({ cell }) =>
        cell && (
          <ToolTip
            style={{
              zIndex: 10,
              right: "100%",
              bottom: "0%",
              width: "25vh",
              height: "25vh",
            }}
            title={<AdminImage src={cell} height={"30vh"} />}
          >
            <AdminImage src={cell} width={50} height={50} />
          </ToolTip>
        ),
      index: "11",
      onClick: ({ cell }) =>
        onDownload(cell, `사업자등록증_${new Date().getTime()}`),
    },
    {
      width: 50,
      text: "소매인 지정서",
      justifyContent: "flex-start",
      code: "businessRetail",
      Cell: ({ cell }) =>
        cell && (
          <ToolTip
            style={{
              zIndex: 10,
              right: "100%",
              bottom: "0%",
              width: "25vh",
              height: "25vh",
            }}
            title={<AdminImage src={cell} height={"30vh"} />}
          >
            <AdminImage src={cell} width={50} height={50} />
          </ToolTip>
        ),
      onClick: ({ cell }) =>
        onDownload(cell, `소매인지정서_${new Date().getTime()}`),
      index: "12",
    },
    {
      width: 60,
      text: "상태",
      justifyContent: "flex-start",
      Cell: ({ row }) => (
        <P>{row?.deleted_at ? "탈퇴" : row.has_account ? "활성" : "비활성"}</P>
      ),
      index: "13",
    },
    {
      width: 50,
      text: "추천인",
      justifyContent: "flex-start",
      Cell: ({ row }) => (
        <ToolTip
          title={
            <P style={{ display: "absolute" }} hover cursor>
              {row?.recommender || "없음"}
            </P>
          }
        >
          <P ellipsis width={50}>
            {row?.recommender || "없음"}
          </P>
        </ToolTip>
      ),
      onClick: ({ row }) => {
        if (row.recommender) {
          navigator.clipboard.writeText(row.recommender);
          toast.success("추천인 아이디를 복사했습니다", {
            autoClose: 1000,
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }
      },
      index: "14",
    },
    {
      width: 60,
      text: "포인트",
      code: "point",
      justifyContent: "flex-start",
      onClick: () => {},
      Cell: ({ row, cell }) => (
        <P
          onClick={() =>
            NiceModal.show("point", { customer: row, setResearch: setResearch })
          }
          cursor
        >
          {Number(cell ? cell : 0).toLocaleString("ko-kr")}
        </P>
      ),
      // Cell: ({ row, cell }) => (
      //   <InputNumber
      //     hideArrow
      //     value={cell}
      //     onKeyDown={(e, value) => {
      //       if (e.key === "Enter" && value !== cell) {
      //         adminRequester.updateCustomer(row.id, { point: Number(value) });
      //       }
      //     }}
      //   />
      // ),
      index: "15",
    },
    {
      width: 140,
      text: "가상계좌/입금액",
      code: "metadata",
      Cell: ({ cell }) =>
        cell?.account ? (
          <VerticalFlex alignItems="flex-end">
            <FlexChild>
              <P>{cell?.account}</P>
            </FlexChild>
            {cell?.amount > 0 && (
              <FlexChild width="max-content">
                <P>{cell?.amount || 0}원</P>
              </FlexChild>
            )}
          </VerticalFlex>
        ) : (
          "데이터 없음"
        ),
      index: "16",
    },
    {
      width: 50,
      text: "편잡",
      Cell: () => <AdminCustomButton text="편집" style={buttonStyle.blue} />,
      onClick: openEdit,
      index: "17",
    },
    {
      width: 80,
      text: "등급",
      code: "groups",
      Cell: ({ cell }) => cell?.[0]?.name || "사업자회원",
      // onClick: openEdit,
      index: "18",
    },
  ];
  //   const outputHeader = [
  //     {
  //       text: "No.",
  //       code: "index",
  //       Cell: ({ index }) => index,
  //       index: "0",
  //     },
  //   ];
  useEffect(() => {
    adminRequester.getCustomerStatus(
      {
        ...extraCondition,
        ...searchCondition,
        offset: page * limit,
        limit: limit,
      },
      (result) => {
        setCount(result.count);
        setMaxPage(result.count / limit);
        setData(result.customers);
      }
    );
  }, [page, searchCondition]);
  useEffect(() => {
    if (reset) {
      setData([]);
      setReset(false);
      setMaxPage(0);
      setCount(0);
    }
  }, [reset]);
  useEffect(() => {
    if (research) {
      adminRequester.getCustomerStatus(
        {
          ...extraCondition,
          ...searchCondition,
          offset: page * limit,
          limit: limit,
        },
        (result) => {
          setCount(result.count);
          setMaxPage(result.count / limit);
          setData(result.customers);
        }
      );
      setResearch(false);
    }
  }, [research]);
  useEffect(() => {
    let indexes = [];
    let buttons = [];
    switch (keyword) {
      case "regist": {
        indexes = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        buttons = ["customerActive"];
        setViews(["RegistManage"]);
        setExtraCondition({ active: "inactive" });
        setSearch(8);
        break;
      }
      default: {
        indexes = [
          0,
          1,
          18,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          16,
          // 14,
          15,
          17,
        ];
        buttons = [
          "customer_reset_moeny",
          "resetPassword",
          "restoreAccount",
          "customerActive",
          "customerInactive",
          "customerDelete",
          "customerRevive",
        ];
        setViews(["AllUserInfo"]);
        setExtraCondition({ deleted: true });
        setSearch(7);
        break;
      }
    }
    // setTheader(indexes.map((index) => theaderList[index]));
    setTheader(
      indexes
        .map((index) => theaderList[index])
        .map((theader) => {
          if (!theader?.onClick) {
            theader.onClick = ({ row }) => openDetail({ row: row });
          }
          return theader;
        })
    );
    setButtons(
      buttons
        .map((code) => TableButton(code, () => setResearch(true)))
        .filter((button) => !!button)
    );
    setReset(true);
  }, [keyword]);
  // useHotkeys("ctrl+k", () => alert("ctrl+k"), { preventDefault: true }, []);
  //   useEffect(() => {
  //     setOuts({
  //       getData: getOutput(outputHeader),
  //     });
  //   }, [outputHeader, extraCondition, searchCondition]);
  const callback = (searchCondition) => {
    setPage(0);
    setSearchCondition(searchCondition);
  };

  const dataCallback = (value) => {
    setData(value);
  };

  //   const getOutput = (outputHeader) => {
  //     const output = async (data, indexes) => {
  //       let list;

  //       if (!indexes || indexes.length === 0) {
  //         list =
  //           (
  //             await adminRequester.getCustomerStatus({
  //               ...extraCondition,
  //               ...searchCondition,
  //             })
  //           ).products || [];
  //       } else {
  //         list = indexes.map((index) => ({
  //           ...data[index],
  //           // index: index + page * limit,
  //         }));
  //       }

  //       return {
  //         header: outputHeader,
  //         list: list,
  //         fileName: `회원정보_${new Date().getTime()}`,
  //       };
  //     };
  //     return output;
  //   };

  return (
    <div className={style.container}>
      <VerticalFlex>
        <FlexChild>
          <HorizontalFlex gap={10} justifyContent="flex-start">
            {views.map((view) => (
              <FlexChild width="max-content">
                <div
                  style={{
                    width: "100%",
                    textAlign: "left",
                    fontSize: 18,
                    paddingBottom: "8px",
                    fontWeight: "700",
                  }}
                  className={clsx({
                    [style.clickable]: views.length > 1 && view !== keyword,
                    [style.selected]: view === keyword && views.length > 1,
                  })}
                  onClick={() => {
                    if (views.length > 0 && view !== keyword)
                      navigator(`/admin/orderStatus/${view}`);
                  }}
                >
                  {t(view)}
                </div>
              </FlexChild>
            ))}
          </HorizontalFlex>
        </FlexChild>
        <FlexChild>
          <TableSearchCard
            callback={callback}
            index={search}
            keyword={keyword}
            reset={reset}
            setReset={setReset}
            research={research}
          />
        </FlexChild>
        <FlexChild>
          <SingleAdminTable
            keyword={keyword}
            theader={theader}
            count={count}
            mockData={data}
            initTabIndex={0}
            callback={dataCallback}
            // output={outs}
            page={page}
            buttons={buttons}
            maxPage={maxPage}
            setPage={setPage}
            limit={limit}
            reset={reset}
            research={research}
          />
        </FlexChild>
      </VerticalFlex>
    </div>
  );
}

export default UserInfoManagementLayout;
